export { COLORS } from './colorsV2'
export { RADIUS } from './radiusV2'
export { SHADOWS } from './shadowsV2'
export * as Text from '../text'
export * as Spacings from '../spacings'
export { devices as Devices, sizes as Sizes } from '../breakpoints'
export const fontFamily = {
	inter: "Inter",   // V2 pages only
	mb:    "'MB_FONT', sans-serif", // legacy brand font
}
